module.exports = "/assets/js/1d6e3bf35511207081d5a75b79299242.svg";